import React, { useEffect, useState } from 'react';
import { PlatformUser, UserRole, Action } from '@twinsketch/topika-model';
import UserService from 'src/services/UserService';
import ErrorModal from 'src/components/common/ErrorModal';
import Header from 'src/components/common/Header';
import 'src/styles/profile-page.css';

const UserProfile: React.FC = () => {
  const [user, setUser] = useState<PlatformUser | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        setLoading(true);
        const fetchedUser = await UserService.getUser();
        setUser(fetchedUser as PlatformUser);
      } catch (err: any) {
        setError('Failed to fetch user.');
      } finally {
        setLoading(false);
      }
    };

    fetchUser();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!user) {
    return <div>No user data available.</div>;
  }

  const formatRole = (role: UserRole) => {
    return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
  };

  const formatPermission = (permission: Action) => {
    return permission.charAt(0).toUpperCase() + permission.slice(1).toLowerCase();
  };

  return (
    <div>
      <Header />
      <ErrorModal message={error} onClose={() => setError(null)} />
      <div className="profile-page">
        <div className="profile-container">
          <h1>Profile</h1>

          {/* Basic Information Section */}
          <section className="profile-section">
            <h2>Basic Information</h2>
            <div className="profile-info">
              <p>
                <strong>Name:</strong> {user.name}
              </p>
              <p>
                <strong>Email:</strong> {user.email}
              </p>
            </div>
          </section>

          {/* Role Section */}
          <section className="profile-section">
            <h2>Role</h2>
            <div className="profile-info">
              <div className="role-badge">{formatRole(user.role)}</div>
            </div>
          </section>

          {/* Permissions Section */}
          <section className="profile-section">
            <h2>Permissions</h2>
            <div className="profile-info">
              {user.permissions && user.permissions.length > 0 ? (
                <div className="permissions-list">
                  {user.permissions.map((permission, index) => (
                    <div key={index} className="permission-badge">
                      {formatPermission(permission)}
                    </div>
                  ))}
                </div>
              ) : (
                <p>No specific permissions assigned.</p>
              )}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
